module.exports = __webpack_public_path__ + "static/media/14UNEP20.cb6c9fb7.jpg";